import { createSliders } from "./image-slider-initialization";

// Select all sliders
const all_sliders = document.querySelectorAll(".image-slider");

// Init sliders using helper function
if (all_sliders) createSliders(all_sliders);
